/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const TimeslotProviderIdentifierFragment = `
    fragment TimeslotProviderIdentifierFragment on ProviderIdentifier {
  id
  type
  value
}
    `
export const TimeSlotProviderFrag = `
    fragment TimeSlotProviderFrag on TimeSlotProvider {
  id
  name
  serviceType
  availabilityStatus
  availabilityNotes
  insurancePlans
  careCoordinatorId
  supervisorId
  genderIdentity
  race
  ethnicity
  languages
  spirituality
  communityIdentity
  clinicalAges
  clinicalModalities
  clinicalSpecialties
  bio
  legalSex
  profession
  licenses {
    licenseType
    stateCode
  }
  identifiers {
    ...TimeslotProviderIdentifierFragment
  }
  tags {
    value
  }
}
    `
export const TimeSlotFrag = `
    fragment TimeSlotFrag on TimeSlot {
  id
  scheduleId
  startDate
  endDate
  startTime
  endTime
  dayOfWeek
  durationMinutes
  serviceCategoryCode
  locations
  provider {
    ...TimeSlotProviderFrag
  }
}
    `
export const TimeSlotSearchResFrag = `
    fragment TimeSlotSearchResFrag on TimeSlotSearchRes {
  results {
    ...TimeSlotFrag
  }
  resultCount
  from
  searchAfter
  aggregations
}
    `
export const TimeSlotSearchDocument = `
    query timeSlotSearch($query: AWSJSON!, $aggregations: AWSJSON, $sort: AWSJSON, $pageSize: Int, $from: Int, $searchAfter: AWSJSON) {
  timeSlotSearch(
    query: $query
    aggregations: $aggregations
    sort: $sort
    pageSize: $pageSize
    from: $from
    searchAfter: $searchAfter
  ) {
    ...TimeSlotSearchResFrag
  }
}
    ${TimeSlotSearchResFrag}
${TimeSlotFrag}
${TimeSlotProviderFrag}
${TimeslotProviderIdentifierFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    timeSlotSearch: build.query<
      Types.TimeSlotSearch,
      Types.TimeSlotSearchVariables
    >({
      query: (variables) => ({ document: TimeSlotSearchDocument, variables }),
    }),
  }),
})

export { injectedRtkApi as api }
